
import React from 'react';
import { Link } from 'react-router-dom';

interface Category {
  id: number;
  name: string;
  slug: string;
  description: string;
  image: string;
  postCount: number;
}

const categories: Category[] = [
  {
    id: 1,
    name: 'Bitcoin',
    slug: 'bitcoin',
    description: 'Everything about Bitcoin, the first and most popular cryptocurrency',
    image: 'https://readdy.ai/api/search-image?query=Bitcoin%20cryptocurrency%20golden%20coin%20with%20blockchain%20network%20background%2C%20modern%20financial%20technology%2C%20clean%20professional%20lighting%2C%20simple%20background&width=300&height=300&seq=cat1&orientation=squarish',
    postCount: 15
  },
  {
    id: 2,
    name: 'Ethereum',
    slug: 'ethereum',
    description: 'Smart contracts, DApps, and the Ethereum ecosystem',
    image: 'https://readdy.ai/api/search-image?query=Ethereum%20cryptocurrency%20logo%20with%20smart%20contract%20visualization%2C%20blockchain%20network%20nodes%2C%20futuristic%20technology%20background%2C%20simple%20clean%20design&width=300&height=300&seq=cat2&orientation=squarish',
    postCount: 12
  },
  {
    id: 3,
    name: 'DeFi',
    slug: 'defi',
    description: 'Decentralized Finance protocols and opportunities',
    image: 'https://readdy.ai/api/search-image?query=DeFi%20decentralized%20finance%20concept%20with%20interconnected%20financial%20symbols%2C%20cryptocurrency%20tokens%2C%20modern%20digital%20banking%20interface%2C%20clean%20background&width=300&height=300&seq=cat3&orientation=squarish',
    postCount: 18
  },
  {
    id: 4,
    name: 'Trading',
    slug: 'trading',
    description: 'Cryptocurrency trading strategies and market analysis',
    image: 'https://readdy.ai/api/search-image?query=Cryptocurrency%20trading%20charts%20with%20candlestick%20patterns%2C%20technical%20analysis%20indicators%2C%20professional%20trading%20dashboard%20interface%2C%20clean%20background&width=300&height=300&seq=cat4&orientation=squarish',
    postCount: 22
  },
  {
    id: 5,
    name: 'NFTs',
    slug: 'nfts',
    description: 'Non-fungible tokens and digital ownership',
    image: 'https://readdy.ai/api/search-image?query=NFT%20non-fungible%20tokens%20digital%20art%20collection%2C%20colorful%20digital%20artwork%20gallery%2C%20blockchain%20technology%20visualization%2C%20simple%20background&width=300&height=300&seq=cat5&orientation=squarish',
    postCount: 8
  },
  {
    id: 6,
    name: 'Security',
    slug: 'security',
    description: 'Blockchain security and cryptocurrency protection',
    image: 'https://readdy.ai/api/search-image?query=Blockchain%20security%20concept%20with%20digital%20lock%2C%20cryptocurrency%20wallet%20protection%2C%20cybersecurity%20shield%2C%20secure%20network%20visualization%2C%20clean%20background&width=300&height=300&seq=cat6&orientation=squarish',
    postCount: 14
  },
  {
    id: 7,
    name: 'Altcoins',
    slug: 'altcoins',
    description: 'Alternative cryptocurrencies and emerging projects',
    image: 'https://readdy.ai/api/search-image?query=Multiple%20cryptocurrency%20coins%20comparison%2C%20diverse%20digital%20currency%20portfolio%20visualization%2C%20colorful%20crypto%20logos%2C%20simple%20clean%20background&width=300&height=300&seq=cat7&orientation=squarish',
    postCount: 25
  },
  {
    id: 8,
    name: 'Mining',
    slug: 'mining',
    description: 'Cryptocurrency mining and blockchain validation',
    image: 'https://readdy.ai/api/search-image?query=Cryptocurrency%20mining%20concept%20with%20computer%20hardware%2C%20blockchain%20network%20processing%2C%20industrial%20technology%20environment%2C%20clean%20background&width=300&height=300&seq=cat8&orientation=squarish',
    postCount: 11
  },
  {
    id: 9,
    name: 'Stablecoins',
    slug: 'stablecoins',
    description: 'Price-stable cryptocurrencies and digital dollars',
    image: 'https://readdy.ai/api/search-image?query=Stablecoins%20cryptocurrency%20USDT%20USDC%20digital%20dollar%20coins%2C%20price%20stability%20chart%2C%20financial%20technology%20background%2C%20simple%20design&width=300&height=300&seq=cat9&orientation=squarish',
    postCount: 9
  },
  {
    id: 10,
    name: 'Web3',
    slug: 'web3',
    description: 'Decentralized internet and blockchain applications',
    image: 'https://readdy.ai/api/search-image?query=Web3%20decentralized%20internet%20concept%2C%20blockchain%20network%20connections%2C%20futuristic%20digital%20world%2C%20interconnected%20nodes%20visualization%2C%20clean%20background&width=300&height=300&seq=cat10&orientation=squarish',
    postCount: 16
  },
  {
    id: 11,
    name: 'Wallets',
    slug: 'wallets',
    description: 'Cryptocurrency wallets and storage solutions',
    image: 'https://readdy.ai/api/search-image?query=Cryptocurrency%20wallets%20hardware%20and%20software%2C%20digital%20security%20concept%2C%20blockchain%20wallet%20interface%2C%20secure%20storage%20visualization%2C%20simple%20background&width=300&height=300&seq=cat11&orientation=squarish',
    postCount: 13
  },
  {
    id: 12,
    name: 'Regulations',
    slug: 'regulations',
    description: 'Cryptocurrency laws and regulatory developments',
    image: 'https://readdy.ai/api/search-image?query=Cryptocurrency%20regulations%20legal%20documents%2C%20government%20policy%2C%20global%20financial%20compliance%2C%20law%20and%20blockchain%20technology%2C%20professional%20background&width=300&height=300&seq=cat12&orientation=squarish',
    postCount: 7
  }
];

const CategoriesPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Section */}
      <div className="bg-white py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Blog Categories</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Explore our comprehensive collection of cryptocurrency and blockchain topics. 
            Find articles organized by category to help you learn and stay updated.
          </p>
        </div>
      </div>

      {/* Categories Grid */}
      <div className="py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {categories.map((category) => (
              <Link
                key={category.id}
                to={`/category/${category.slug}`}
                className="group"
              >
                <div className="bg-white rounded-[20px] shadow-sm border border-gray-100 p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                  <div className="aspect-square mb-4 overflow-hidden rounded-[20px]">
                    <img
                      src={category.image}
                      alt={category.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors">
                    {category.name}
                  </h3>
                  <p className="text-gray-600 text-sm mb-3 line-clamp-2">
                    {category.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-500">
                      {category.postCount} articles
                    </span>
                    <i className="ri-arrow-right-line text-blue-600 group-hover:translate-x-1 transition-transform"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoriesPage;
